module.exports = __webpack_public_path__ + "img/Pakistan.49e1d5e6.png";